import { useQuery } from '@tanstack/react-query';
import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../../lib/axios';
import { ActivityReportingRequirementsViewModel } from '../../../../../features/activities/editActivity/editReportingRequirements/types';

async function get(companyId: number | undefined, travellerIds: number[]) {
  return (await getAxios().get(`${ActivityEndpoints.reportingRequirements.getNew(companyId!, travellerIds)}`)).data;
}

export function useNewActivityReportingRequirementsModelQuery(companyId: number | undefined, travellerIds: number[]) {
  return useQuery<ActivityReportingRequirementsViewModel>({
    queryKey: [ActivityEndpoints.reportingRequirements.getNew(companyId!, travellerIds)],
    retry: false,
    queryFn: () => get(companyId, travellerIds),
    enabled: !!companyId
  });
}
